import type { SearchIndexEntry } from "@/types";

export interface SearchResponse {
  query: string;
  results: SearchIndexEntry[];
}

function apiBase(): string {
  if (import.meta.env.DEV) return "";
  return (import.meta.env.VITE_WIDGET_API_URL || "").replace(/\/+$/, "");
}

export async function searchArchive(
  query: string,
  limit = 80
): Promise<SearchIndexEntry[]> {
  const ragTarget = import.meta.env.VITE_RAG_TARGET || "chz";
  const params = new URLSearchParams({
    q: query,
    limit: String(limit),
    rag_target: ragTarget,
  });
  const res = await fetch(`${apiBase()}/api/search?${params}`);
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const body = await res.json();
      if (typeof body?.detail === "string") detail = body.detail;
    } catch {
      /* ignore */
    }
    throw new Error(detail);
  }
  const data = (await res.json()) as SearchResponse;
  return data.results;
}

